import { createContext, ReactNode, useContext } from 'react';

import type { AiAssistantSocket } from '@mint-sdk/api-ai-assistant';

type ChatTarget = AiAssistantSocket.ChatTarget;

export const DEFAULT_CHAT_TARGET: ChatTarget = {
  isOverride: false,
  context: null,
  action: null,
  feature: null,
};

const ChatTargetContext = createContext<ChatTarget>(DEFAULT_CHAT_TARGET);

type ChatTargetProviderProps = {
  target?: ChatTarget;
  children: ReactNode;
};

export const ChatTargetProvider = ({
  target = DEFAULT_CHAT_TARGET,
  children,
}: ChatTargetProviderProps) => (
  <ChatTargetContext.Provider value={target}>
    {children}
  </ChatTargetContext.Provider>
);

export const useChatTarget = (): ChatTarget => useContext(ChatTargetContext);
